/*
 * @Description: 整个游戏的启动场景,该场景只有一张背景图
 * @Author: lxx
 * @Date: 2024-04-08 09:49:46
 * @FilePath: /BackpackBattle/assets/boot/scripts/BootSceneView.ts
 */


import { SLS_TRACER } from '@aliyun-sls/web-trace-mini';
import * as CryptoJS from "crypto-js";
import { loadingCache, SceneId } from './LoadingCache';
const { ccclass, property } = cc._decorator;



@ccclass
export default class BootSceneView extends cc.Component {
    @property({ displayName: "设计尺寸" })
    public designSize: cc.Size = cc.size(720, 1280);

    @property({ type: cc.Node, displayName: "开始游戏按钮" })
    ndStartGame: cc.Node = null;

    @property({ type: cc.Sprite, displayName: "进度条Bar" })
    spLoading: cc.Sprite = null;

    @property({ type: cc.Label, displayName: "进度条描述" })
    labProgressDesc: cc.Label = null;


    private progress: number = 0;
    private totalCount: number = 0;
    private currentCount: number = 0;

    private maxProgress: number = 0;
    private maxNextProgress: number = 0;

    private canUpdate: boolean = false;

    private startTime: number = 0;


    private _platform: string = "tt";


    protected async onLoad() {
        this.spLoading.fillRange = 0;
        this.startTime = Date.now();
        cc.debug.setDisplayStats(false);
        loadingCache.reportScene(SceneId.S1, 0);
        this.scheduleOnce(() => {
            this.startLoading();
            this.canUpdate = true;
        }, 0);
    }

    private startLoading() {
        window["CryptoJS"] = CryptoJS;
        window["SLS_TRACER"] = SLS_TRACER;

        this.ndStartGame.active = false;
        this.spLoading.node.parent.active = true;
        this.spLoading.fillRange = 0;

        this.fixDesignSolution();

        let bundles = [
            "resources",
            "main",
            "nysdk",
            "game",
        ];

        this.reportPlayerNum();

        this.currentCount = 0;
        this.totalCount = bundles.length;

        this.maxNextProgress = (this.currentCount + 1) / this.totalCount;
        let componentFun = () => {
            if (++this.currentCount === this.totalCount) {
                let bundle = cc.assetManager.getBundle("game");
                if (!bundle) {
                    // bundle加载失败卡主了
                    this.reportCrash();
                    this.showResetStartGameUI();
                    return;
                }
                let tStartTime: number = Date.now();
                bundle.loadScene("scene/loading", (err1, ddd) => {
                    this.maxNextProgress = 1;
                    loadingCache.loadingTime1 = Math.floor((Date.now() - this.startTime) / 1000);
                    loadingCache.reportScene(SceneId.S3, Date.now() - tStartTime);
                    cc.director.runScene(ddd);
                });
            };
            this.maxProgress = this.currentCount / this.totalCount;
            this.maxNextProgress = Math.min((this.currentCount + 1) / this.totalCount, 0.9);
        }

        // 此处要按顺序加载
        let loadBundleFun = (index) => {
            if (index >= bundles.length) { return; }
            loadingCache.loadBundle(bundles[index], (costTime: number) => {
                if (bundles[index] === "game") {
                    loadingCache.reportScene(SceneId.S2, costTime);
                }
                componentFun();
                loadBundleFun(++index);
            })

        }
        loadBundleFun(0);
    }

    private showResetStartGameUI() {
        this.ndStartGame.active = true;
        this.spLoading.node.parent.active = false;
    }

    protected onBtnResetStartGameClick() {
        this.startLoading();
    }

    /**
     * 统计进入玩家数量
     */
    private reportPlayerNum() {
        return;
        let fristLoigin = cc.sys.localStorage.getItem("isFristLoigin");
        if (fristLoigin === "false") {
            return;
        }
        cc.sys.localStorage.setItem("isFristLoigin", "false");
        let xhr = cc.loader.getXMLHttpRequest();
        xhr.open("post", `https://platform.tomato123.cn/lem/littlegame/bp/record/init?channel=${this._platform}`);
        xhr.onreadystatechange = (ev) => {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    console.log("请求成功!!!!!");
                }
            }
        }
        xhr.send();


    }

    private reportCrash() {
        return;
        cc.sys.localStorage.setItem("isFristLoigin", "false");
        let xhr = cc.loader.getXMLHttpRequest();
        xhr.open("post", `https://platform.tomato123.cn/lem/littlegame/bp/record/crash?channel=${this._platform}`);
        xhr.onreadystatechange = (ev) => {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    console.log("请求成功!!!!!");
                }
            }
        }
        xhr.send();
    }


    private fixDesignSolution() {
        let frameSize = cc.view.getVisibleSize();
        // tslint:disable-next-line:one-variable-per-declaration
        let policy,
            e = cc.ResolutionPolicy;
        policy = e.FIXED_HEIGHT;

        let designRes = cc.size(this.designSize.width, this.designSize.height);

        // tslint:disable-next-line:one-variable-per-declaration
        let w = frameSize.width,
            h = frameSize.height;
        // tslint:disable-next-line:one-variable-per-declaration
        let scaleX = w / designRes.width,
            scaleY = h / designRes.height;
        scaleX < scaleY
            ? ((designRes.width = designRes.width), (designRes.height = Math.ceil(h / scaleX)))
            : ((designRes.width = Math.ceil(w / scaleY)), (designRes.height = designRes.height));
        cc.view.setDesignResolutionSize(designRes.width, designRes.height, policy);
    }

    protected update(dt: number): void {
        if (!this.canUpdate) {
            return;
        }
        this.progress += dt * 0.1;
        if (this.progress < this.maxProgress) {
            this.progress = this.maxProgress;
        }
        this.progress = Math.min(this.maxProgress, this.progress);
        if (this.progress > this.maxNextProgress) {
            this.progress = this.maxNextProgress;
        }
        this.spLoading.fillRange = this.progress;
        this.labProgressDesc.string = "正在加载资源" + Math.floor((this.progress * 100)) + "%"
    }

}
